
import "./jquery-global.js";
import $ from "jquery";
import "bootstrap";

import "./custom.js";

import "./modules/vanilla-lazyload/vanilla-lazyload.js";
import "./modules/mainslider/mainslider.js";  
import "./modules/mmenu-js/mmenu-js.js"; 
import "./modules/counter/counter.js";
import "./modules/bootstrap-select/bootstrap-select.js";
import "./modules/testimonial/testimonial.js";
import "./modules/immolist/immolist.js";
import "./modules/expose/expose.js";